import api from "../../services/api";

const APIS = {
    REGISTER_NEW_USER: "/users/register-new-user-recaptcha",
    SAVE_REGISTERED_USER_BY_ADMIN: "/Users/saveregistereduser-by-admin",
    GET_REGISTERED_USER_BY_EMAIL: "/Users/get-registered-user-by-email",
    COUNTRIES_WITH_STATES: "/Location/countries-with-states",
    SALES_REPRESENTATIVE_LIST: "/Users/fieldstaff-names",
    FORGOT_PASSWORD: "/Users/forgot-password"
};

export const registerNewUser = async (userData) => {
    try {
        const requestBody = {
            companyName: userData.companyName,
            locationName: userData.location,
            address: userData.address,
            country: userData.country,
            state: userData.state,
            city: userData.city,
            zipCode: userData.zipCode,
            phone: userData.phone,
            fax: userData.fax || "",
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email?.trim().toLowerCase() || "",
            salesRep: userData.rep,
            recaptchaToken: userData.recaptchaToken || "",
            companyId: 0,
            locationId: 0
        };

        const res = await api.post(APIS.REGISTER_NEW_USER, requestBody);
        return {
            success: res.data.success,
            id: res.data.id,
            data: res.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.message || "Registration failed"
        };
    }
};

export const saveRegisteredUserByAdmin = async (userData) => {
    try {
        const requestBody = {
            companyName: userData.companyName,
            locationName: userData.location,
            address: userData.address,
            country: userData.country,
            state: userData.state,
            city: userData.city,
            zipCode: userData.zipCode,
            phone: userData.phone,
            fax: userData.fax || "",
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email?.trim().toLowerCase() || "",
            salesRep: userData.rep,
            companyId: 0,
            locationId: 0
        };

        const res = await api.post(APIS.SAVE_REGISTERED_USER_BY_ADMIN, requestBody);
        return {
            success: true,
            data: res.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.message || "Save operation failed"
        };
    }
};

export const getRegisteredUserByEmail = async (email) => {
    try {
        const res = await api.get(`${APIS.GET_REGISTERED_USER_BY_EMAIL}?email=${encodeURIComponent(email?.trim().toLowerCase() || "")}`);
        return {
            success: true,
            data: res.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.message || "Failed to fetch user data"
        };
    }
};

export const getCountriesWithStates = async () => {
    try {
        const res = await api.get(APIS.COUNTRIES_WITH_STATES);
        return {
            success: true,
            data: Array.isArray(res.data) ? res.data : []
        };
    } catch (error) {
        return {
            success: false,
            data: [],
            error: error.response?.data?.message || "Failed to fetch countries and states"
        };
    }
};
export const getFieldStaffNames = async () => {
  try {
    const response = await api.get(APIS.SALES_REPRESENTATIVE_LIST);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const forgotPassword = async (email) => {
    try {
        const requestBody = {
            email: email?.trim().toLowerCase() || ""
        };

        const res = await api.post(APIS.FORGOT_PASSWORD, requestBody);

        const data = res.data;

        if (typeof data === 'string' && data.toLowerCase().includes('notfound')) {
            return {
                success: false,
                error: 'Email not found. Please check your email address.'
            };
        }

        if (typeof data === 'object' && data.success === false) {
            return {
                success: false,
                error: data.message || 'Failed to send reset link.'
            };
        }

        return {
            success: true,
            message: data.message || 'Password reset link sent successfully.'
        };
    } catch (error) {
        if (error.response) {
            const statusCode = error.response.status;
            const errorData = error.response.data;

            if (typeof errorData === 'string' && errorData.toLowerCase().includes('notfound')) {
                return {
                    success: false,
                    error: 'Email not found. Please check your email address.'
                };
            }

            const errorMessage = typeof errorData === 'string' ? errorData : errorData?.message || errorData;

            switch (statusCode) {
                case 404:
                    return {
                        success: false,
                        error: errorMessage || 'Email not found. Please check your email address.'
                    };
                case 400:
                    return {
                        success: false,
                        error: errorMessage || 'Invalid email format.'
                    };
                case 500:
                    return {
                        success: false,
                        error: 'Server error. Please try again later.'
                    };
                default:
                    return {
                        success: false,
                        error: errorMessage || 'Failed to send reset link. Please try again.'
                    };
            }
        } else {
            return {
                success: false,
                error: 'Network error. Please check your internet connection.'
            };
        }
    }
};
